import React from 'react';
import {APP_NAME} from "../../envs/_current/config";
import useTranslate from "../../modules/local/useTranslate";
import logo from 'assets/svgs/applogo.svg'
import {AppLogoSvg} from "../../appConfigs/svgs/AppLogoSvg";

const styles = {
    container: {
        padding: '12px 16px',
        background: '#ffffff',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    appIcon: {
        width: '44px',
        height: '44px',
        borderRadius: '10px',
        // background: 'linear-gradient(135deg, #ff922b 0%, #f56e0f 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 10px rgba(255, 146, 43, 0.2)',
        flexShrink: 0,
    },
    content: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    },
    title: {
        fontSize: '14px',
        fontWeight: '700',
        color: '#1a1a1a',
        margin: 0,
    },
    subtitle: {
        fontSize: '12px',
        color: '#666',
        margin: 0,
    },
    btnUpdate: {
        background: '#007aff', // Màu xanh đặc trưng của Store (hoặc dùng #ff922b nếu muốn đồng bộ brand)
        color: '#fff',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },
    btnClose: {
        background: 'none',
        border: 'none',
        color: '#999',
        fontSize: '18px',
        padding: '4px',
        marginLeft: '-4px',
        cursor: 'pointer',
        lineHeight: 1,
    }
};

export default function UpdateBanner({
                                         force = false,
                                         storeUrl,
                                         onClose,
                                         icon: IconComponent = AppLogoSvg,
                                         iconUrl = logo,
                                         appName = APP_NAME
                                     }) {
    const t = useTranslate();
    const handleUpdate = () => {
        const target = window.cordova ? '_system' : '_blank';
        window.open(storeUrl, target);

        if (window.cordova) {
            setTimeout(() => {
                if (force) {
                    navigator.app.exitApp();
                }
            }, 500);
        }
    };

    return (
        <div style={styles.container}>
            {!force && (
                <button style={styles.btnClose} onClick={onClose} aria-label="Close">
                    ×
                </button>
            )}

            <div style={styles.appIcon}>
                {/* Ưu tiên IconComponent, sau đó đến iconUrl, cuối cùng là emoji mặc định */}
                {IconComponent ? (
                    <IconComponent style={{width: '28px', height: '28px'}}/>
                ) : iconUrl ? (
                    <img src={iconUrl} alt="App Icon" style={{width: '100%', height: '100%', borderRadius: '10px'}}/>
                ) : (
                    <span style={{color: 'white', fontSize: '20px'}}>🚀</span>
                )}
            </div>

            <div style={styles.content}>
                <h4 style={styles.title}>{APP_NAME}</h4>
                <p style={styles.subtitle}>{t("A new version is available. Please update to continue.")}</p>
            </div>

            <button style={styles.btnUpdate} onClick={handleUpdate}>
                {force ? t("update") : t("open")}
            </button>
        </div>
    );
}